import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
  Button,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  TextField,
  FormControl,
  InputLabel,
  Tooltip,
} from "@material-ui/core";
import jsPDF from "jspdf";
import InterFont from "../../fonts/Inter.ttf";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { Toolbar, AppBar } from "@material-ui/core";
import { ToastContainer } from "react-toastify";
import infoaptoLogo from "../../images/logo/Info_logo_trans.png";
import signatoryAuthorized from "../../images/png/signatory_authorized_person.png";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import Cropper from "react-easy-crop";
import axios from "axios";
import { toast } from "react-toastify";
import Notification from "../../components/Notification";
import useStyles from "../../themes/style";
import { useHistory } from "react-router-dom";
import CloseIcon from "@material-ui/icons/Close";
import red from "@material-ui/core/colors/red";
import "react-toastify/dist/ReactToastify.css";
import getCroppedImg from "../../utils/croppedImage";
import { jwtDecode } from "jwt-decode";
import "../../css/agreement-resume.css";
import moment from "moment";
const positions = [toast.POSITION.TOP_RIGHT];

// const ImageInput = () => {
//     const classes = useStyles();
//     const { register } = useFormContext();
//     const { ref, ...fields } = register('cardImage');
//     const inputRef = React.useRef();
//     const pickImageHandler = () => {
//         inputRef.current?.click();
//     };

//     return (
//         <>
//             <input
//                 type="file"
//                 accept=".jpg,.png,.jpeg"
//                 style={{ display: 'none' }}
//                 {...fields}
//                 ref={(instance) => {
//                     ref(instance);
//                     inputRef.current = instance;
//                 }}
//             />
//             <Button className={classes.button} type="button" variant="contained" onClick={pickImageHandler}>
//                 Add Image
//             </Button>
//         </>
//     );
// };

function VendorDisclosureAgreement() {
  const token = localStorage.getItem("token");
  const decode = jwtDecode(token);
  const history = useHistory();
  const agreementfileRef = useRef(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [hideActionBtns, setHideActionBtns] = useState(false);
  const [signData, setSignData] = useState({});
  const [userDetails, setUserDetails] = useState({});

  const handleModalClose = () => {
    setModalOpen(false);
  };
  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const getMuiTheme = () =>
    createTheme({
      overrides: {
        MuiAvatar: {
          root: {
            fontFamily: '"Satoshi"',
          },
        },
        MuiMenuItem: {
          root: {
            fontFamily: '"Satoshi"',
          },
        },
        MUIDataTableToolbar: {
          actions: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          },
          icon: {
            color: "#064be2",
            "& svg": {
              color: "white",
              width: "25px",
              cursor: "pointer",
              height: "25px",
              padding: "5px",
              boxShadow: "0 3px 9px 0 rgba(0,0,0,0.3)",
              borderRadius: "100%",
              backgroundColor: "#064be2",
            },
          },

          iconActive: {
            color: "#064be2",
            "& svg": {
              color: "white",
              width: "25px",
              cursor: "pointer",
              height: "25px",
              padding: "5px",
              boxShadow: "0 3px 9px 0 rgba(0,0,0,0.3)",
              borderRadius: "100%",
              backgroundColor: "#064be2",
            },
          },
        },
        MUIDataTableBody: {
          emptyTitle: {
            "@media (max-width: 425px)": {
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            },
            "@media (max-width: 959.95px)": {
              marginLeft: "-100px",
            },
          },
        },

        MUIDataTableBodyCell: {
          stackedCommon: {
            "@media (max-width:959.95px)": {
              fontSize: "13px !important",
              "&:nth-last-child(2)": { fontWeight: 700 },
              "&:last-child": { lineBreak: "anywhere" },
            },
          },
          responsiveStackedSmallParent: {
            "@media (max-width:425px)": { width: "93%" },
          },
        },
        MuiTable: {
          root: {
            "& caption": { fontFamily: '"Satoshi" !important' },
          },
        },
        MuiBadge: {
          badge: {
            height: "30px!important",
            fontFamily: '"Satoshi" !important',
          },
          colorSecondary: {
            backgroundColor: red[500] + "!important",
          },
          anchorOriginTopLeftCircular: {
            top: "14%",
            left: "-21px",
            inlineSize: "max-content",
          },
        },
        MuiTableCell: {
          head: {
            color: "#121224",
            backgroundColor: "#f0f5f9 !important",
            fontSize: "15px !important",
            fontWeight: "bold",
            letterSpacing: "0.02em",
          },
          body: {
            color: "#121224",
            fontFamily: '"Satoshi" !important',
            fontSize: "13.5px !important",
            "&:last-child": { whiteSpace: "nowrap" },
          },

          root: {
            padding: "14px",
            fontFamily: '"Satoshi" !important',
          },
          paddingCheckbox: {
            "@media (max-width:959.95px)": { width: "10px" },
          },
        },
        MuiList: {
          padding: {
            paddingBottom: "0px !important",
          },
        },
        MuiListItem: {
          secondaryAction: {
            paddingRight: "45px !important",
          },
        },
        MuiSelect: {
          select: {
            "&:focus": { backgroundColor: "none !important" },
          },
        },

        MuiTableRow: {
          root: {
            "&:nth-of-type(odd)": { backgroundColor: "white" },
            "&:nth-of-type(even)": { backgroundColor: "#f0f5f9" },
          },
        },

        MuiIconButton: {
          root: {
            padding: "9px",
          },
        },

        MuiTypography: {
          subtitle1: {
            fontSize: "1rem",
            fontWeight: "500",
            fontFamily: '"Satoshi" !important',
            "@media (max-width:959.95px)": { fontSize: "0.9rem !important" },
          },
          subtitle2: {
            fontWeight: "500",
            fontFamily: '"Satoshi" !important',
            textAlign: "center",
            padding: "10px",
            fontSize: "21px",
            "@media (max-width:959.95px)": {
              fontSize: "calc(1.1rem) !important",
            },
          },
          body1: {
            fontFamily: '"Satoshi" !important',
            fontSize: "14px",
            "@media (max-width:959.95px)": { fontSize: "13px !important" },
          },
          body2: {
            color: "#121224",
            fontFamily: '"Satoshi" !important',
            fontSize: "14px",
            "@media (max-width:959.95px)": { fontSize: "13px !important" },
          },
          h5: {
            color: "#121224",
            fontFamily: '"Satoshi" !important',
            fontSize: "14px",
            "@media (max-width:959.95px)": {
              fontSize: "calc(1.1rem) !important",
            },
          },
          h6: {
            color: "#121224",
            fontFamily: '"Satoshi" !important',
            fontSize: "14px",
            "@media (max-width:959.95px)": {
              fontSize: "calc(1.1rem) !important",
            },
          },
        },
        MuiPaper: {
          elevation4: {
            boxShadow: "none",
          },
        },

        MuiDialog: {
          paper: {
            margin: "15px !important",
            border: "1px solid #000 !important",
          },
        },

        MuiFab: {
          root: {
            "&:hover": {
              backgroundColor: "064be2 !important",
            },
          },
        },
        MuiButton: {
          root: {
            fontFamily: '"Satoshi !important"',
            fontSize: "14px",
            fontWeight: 500,
            boxShadow: "0 3px 9px 0 rgba(0,0,0,0.3) !important",
            "@media (max-width:959.95px)": { fontSize: "10px !important" },
          },
          label: {
            fontFamily: '"Satoshi" !important',
            fontSize: "14px",
            "@media (max-width:959.95px)": { fontSize: "10px !important" },
          },
          containedPrimary: {
            backgroundColor: "#064be2 !important",
            textTransform: "initial !important",
            "&:active": {
              backgroundColor: "#064be2 !important",
              color: "#fff !important",
            },
            "&:hover": {
              backgroundColor: "#064be2 !important",
              color: "#fff !important",
            },
            "&:disabled": {
              backgroundColor: "#064be2c7 !important",
              color: "#fff !important",
            },
          },
          containedSizeSmall: {
            textTransform: "initial !important",
            padding: "4px 10px !important",
            fontWeight: "300 !important",
            height: "fit-content !important",
          },
          containedSecondary: {
            backgroundColor: red[500] + "!important",
            "&:active": {
              backgroundColor: red[500] + "!important",
              color: "#fff !important",
            },
            "&:hover": {
              backgroundColor: red[500] + "!important",
              color: "#fff !important",
            },
          },
        },
        MuiFormLabel: {
          root: {
            fontFamily: '"Satoshi" !important',
            fontSize: "20px",
            "@media (max-width:959.95px)": { fontSize: "15px !important" },
            color: "rgba(0, 0, 0, 0.87)",
          },
        },
        MuiCheckbox: {
          root: {
            color: "#bcbdbf",
          },
        },
        MuiFormControl: {
          root: {
            width: "100%",
          },
        },
        MuiTooltip: {
          tooltip: {
            fontFamily: '"Satoshi" !important',
          },
          // popper:{
          //   top: "-34px !important",
          //   left: '-45px !important'
          // }
        },
        MuiInputBase: {
          root: {
            width: "100%",
          },
          input: {
            width: "100%",
            border: "none",
            fontSize: "13px",
            display: "block",
            padding: "10px 12px !important",

            borderRadius: "4px",
          },
        },

        MuiAutocomplete: {
          input: {
            width: "100% !important",
          },
        },

        MuiFilledInput: {
          root: {
            width: "100%",
            display: "block",
            padding: "0px 25px 0px 0px !important",
            position: "relative",
            fontSize: "13px",
            marginTop: "24px",

            backgroundColor: "white",
            "&:hover": { backgroundColor: "unset !important" },
            "&.Mui-focused": { backgroundColor: "unset !important" },
          },

          underline: {
            "&&&:before": { borderBottom: "none" },
            "&&:after": { borderBottom: "none" },
          },
          inputAdornedEnd: {
            border: "1px solid #ced4da",
          },
        },

        MuiOutlined: {
          MuiChip: {
            avatar: { margin: "0px" },
          },
        },

        MuiCardContent: {
          root: {
            marginBottom: "10px !important",
            "&:last-child": { paddingBottom: "0px" },
          },
        },
        MuiDrawer: {
          paperAnchorBottom: {
            width: "50%",
            left: "30%",
            bottom: "10%",
          },
          paper: {
            overflowY: "auto",
            overflowX: "hidden",
          },
        },
        MuiDialogTitle: {
          root: {
            padding: "0px 10px !important",
          },
        },

        MuiChip: {
          avatar: {
            width: "50px !important",
            height: "50px !important",
            fontSize: "1.5rem !important",
            margin: "0px",
          },
        },
        MuiInputLabel: {
          shrink: {
            width: "max-content",
            display: "initial !important",
            transformOrigin: "top left !important",
            fontSize: "16px",
          },
        },
      },

      MuiFormGroup: {
        row: {
          marginTop: "10px !important",
        },
      },
    });

  const validationSchema = Yup.object().shape({
    fullName: Yup.string()
      .max(255)
      .required("Name is required")
      .max(255)
      .matches(/^[^!@#$%^&*+=<>:;|~]*$/, {
        message: "Name Must be Alphanumeric",
      }),
    address: Yup.string().required("Address is required"),
    personName: Yup.string().required("Authorized Person Name is required"),
    designation: Yup.string().required("Designation is required"),
    apartment: Yup.string().nullable().notRequired(),
    city: Yup.string().required("City name is required"),
    postalCode: Yup.string().required("ZIP/postal code is required"),
    state: Yup.string().required("State/province is required"),
  });

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(validationSchema) });

  var [errorToastId, setErrorToastId] = useState(null);
  var [notificationsPosition] = useState(2);

  const theme = useTheme();
  const classes = useStyles();
  const isMatch = useMediaQuery(theme.breakpoints.down("sm"));

  function sendNotification(componentProps, options) {
    return toast(
      <Notification
        {...componentProps}
        className={classes.notificationComponent}
      />,
      options,
    );
  }

  function handleNotificationCall(notificationType, message) {
    var componentProps;
    if (errorToastId && notificationType === "error") return;

    switch (notificationType) {
      case "info":
        componentProps = {
          type: "feedback",
          message: message,
          variant: "contained",
          color: "primary",
        };
        break;
      case "error":
        componentProps = {
          type: "message",
          message: message,
          variant: "contained",
          color: "secondary",
        };
        break;
      default:
        componentProps = {
          type: "shipped",
          message: message,
          variant: "contained",
          color: "success",
        };
    }

    var toastId = sendNotification(componentProps, {
      type: notificationType,
      position: positions[notificationsPosition],
      progressClassName: classes.progress,
      onClose: notificationType === "error" && (() => setErrorToastId(null)),
      className: classes.notification,
    });

    if (notificationType === "error") setErrorToastId(toastId);
  }

  const styles = {
    grandMasterContainer: {
      minWidth: "800px",
      minHeight: "1000px",
      margin: "auto",
      maxWidth: "800px",
    },
    masterContainer: {
      minWidth: "802px",
      maxHeight: "1115px",
      maxWidth: "800px",
      margin: "40px auto",
      padding: "16px",
      border: "1px solid #eee",
      fontSize: "16px",
      lineHeight: "24px",
      fontFamily: "'Inter', sansSerif",
      color: "#555",
      backgroundColor: "#F9FAFC",
      // filter: "blur(0px)",
    },
    masterContainerTwo: {
      minWidth: "802px",
      maxHeight: "1115px",
      maxWidth: "800px",
      margin: "60px auto",
      padding: "16px",
      border: "1px solid #eee",
      fontSize: "16px",
      lineHeight: "24px",
      fontFamily: "'Inter', sansSerif",
      color: "#555",
      backgroundColor: "#F9FAFC",
      // filter: "blur(0px)",
    },
    masterContainerThree: {
      minWidth: "802px",
      maxHeight: "1115px",
      maxWidth: "800px",
      margin: "120px auto 80px",
      padding: "16px",
      border: "1px solid #eee",
      fontSize: "16px",
      lineHeight: "24px",
      fontFamily: "'Inter', sansSerif",
      color: "#555",
      backgroundColor: "#F9FAFC",
    },
    masterContainerFour: {
      minWidth: "802px",
      maxHeight: "1115px",
      maxWidth: "800px",
      margin: "100px auto 80px",
      padding: "16px",
      border: "1px solid #eee",
      fontSize: "16px",
      lineHeight: "24px",
      fontFamily: "'Inter', sansSerif",
      color: "#555",
      backgroundColor: "#F9FAFC",
    },
  };

  function handleAddAgreement(values) {
    setSignData({ ...values });
    if (imageSrc) {
      handleModalClose();
    } else {
      handleNotificationCall("info", "Please select signature");
    }
  }

  const [loader, setLoader] = useState(false);

  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImgae, setCroppedImage] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const currentTodayDate = moment(new Date()).format("DD");
  const currentTodayMonth = moment(new Date()).format("MMMM");
  const currentTodayyear = moment(new Date()).format("YYYY");

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      if (file && file?.size >= 2000000) {
        handleNotificationCall("info", "Maximum File Size Limit 2mb");
        return;
      }
      const reader = new FileReader();
      reader.addEventListener("load", () => setImageSrc(reader.result));
      reader.readAsDataURL(file);
      setShowModal(true);
    }
  };

  const onCropComplete = useCallback(
    async (croppedArea, croppedAreaPixels) => {
      const croppedImageBlob = await getCroppedImg(imageSrc, croppedAreaPixels);
      setCroppedAreaPixels(croppedAreaPixels);
      const reader = new FileReader();
      reader.readAsDataURL(croppedImageBlob);
      reader.onloadend = () => {
        setCroppedImage(reader.result); // This will be a base64 data URL
      };
    },
    [imageSrc],
  );

  const handleUpload = async () => {
    if (!croppedAreaPixels || !imageSrc) return;
    const croppedImageBlob = await getCroppedImg(imageSrc, croppedAreaPixels);

    if (croppedImageBlob.size > 3 * 1024 * 1024) {
      alert("The cropped image size exceeds 3MB. Please crop again.");
      return;
    }
    setShowModal(false);
  };

  const handleGeneratePdf = async () => {
    setHideActionBtns(true);
    if (!croppedImgae) {
      handleNotificationCall("info", " please Attach your Signature");
      setHideActionBtns(false);
      return;
    }
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
      compress: true,
      lineHeight: 1.2,
    });

    doc.addFont(InterFont, "Inter", "normal");
    doc.setFont("Inter");
    const element = agreementfileRef.current;
    if (element) {
      await doc.html(element, {
        callback: (doc) => {
          const pdfBlob = doc.output("blob");
          handleAgreementSign(pdfBlob, doc);
        },
        x: 10,
        y: 10,
        html2canvas: {
          scale: 0.7, // Adjust the scale for better quality
          logging: true, // Enable logging for debugging
          useCORS: true,
          letterRendering: false,
        },
        windowWidth: 800,
      });
    }
  };

  const handleClearFormData = () => {
    reset();
    setImageSrc(null);
    setCroppedImage(null);
    handleModalOpen();
  };

  async function handleAgreementSign(pdfBlob, doc) {
    setLoader(true);
    const formData = new FormData();
    const nonDisclosureFile = new File(
      [pdfBlob],
      `non-disclosure_agreement${Date.now()}.pdf`,
    );
    formData.append("nda", nonDisclosureFile);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}recruiter/setUserNda`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: token,
          },
        },
      );

      if (response.data.status === true) {
        handleNotificationCall("success", response.data.message);
        doc.save(`non-disclosure_agreement${Date.now()}.pdf`);
        localStorage.removeItem("profileMenuName");
        // window.location.reload();
        history.push("/app/dashboard")
      } else {
        handleNotificationCall("error", response.data.message);
        setHideActionBtns(false);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      setHideActionBtns(false);
    } finally {
      setLoader(false);
    }
  }

  function fetchUserData() {
    setLoader(true);
    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}recruiter/viewUsers`,
      data: {
        id: decode.user_id,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    })
      .then(function (response) {
        if (response.data.status === true) {
          const resposeData = response.data.data;
          setUserDetails(resposeData);
          if (resposeData && resposeData.recruiter?.nda) {
            // history.push("/app/dashboard");
          }
        }
        setLoader(false);
      })
      .catch(function (error) {
        setLoader(false);
        console.log(error);
      });
  }

  useEffect(() => {
    fetchUserData();
    setModalOpen(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classes.backgroundColor}>
      <MuiThemeProvider theme={getMuiTheme()}>
        <>
          <AppBar className={classes.appBarBg}>
            <Toolbar className={classes.toolbarLP}>
              {isMatch ? (
                <>
                  <div className={classes.refoTitleMobile}>
                    <p className="refo-name">refo</p>
                  </div>
                  <div className={classes.flexCenter} style={{ width: "100%" }}>
                    <div className="refo-full-name">
                      <h1>
                        refo<span>recruiter essentials & faster outcomes</span>
                      </h1>
                    </div>
                  </div>
                  {/* <DrawerComp /> */}
                </>
              ) : (
                <Grid className={classes.gridCenter} container spacing={2}>
                  <Grid item xs={1} md={1} className={classes.refoTitle}>
                    <p className="refo-name">refo</p>
                  </Grid>
                  <Grid item xs={11} md={11} className={classes.flexCenter}>
                    <div className="refo-full-name">
                      <h1>
                        refo<span>recruiter essentials & faster outcomes</span>
                      </h1>
                    </div>
                  </Grid>
                </Grid>
              )}
            </Toolbar>
          </AppBar>

          <div style={{ marginTop: "5rem", overflow: "auto" }}>
            <div ref={agreementfileRef} style={styles.grandMasterContainer}>
              <div style={styles.masterContainer}>
                <table
                  style={{
                    fontSize: "12px",
                    lineHeight: "20px",
                    width: "100%",
                  }}
                >
                  <thead>
                    <tr>
                      <td style={{ textAlign: "center", margin: "0" }}>
                        <img
                          src={infoaptoLogo}
                          width="400"
                          alt="logo_company"
                          style={{
                            display: "block",
                            margin: " 0 auto",
                            padding: "20px",
                          }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center", margin: "0" }}>
                        <h2
                          style={{
                            fontSize: "16pt",
                            fontWeight: "600",
                            color: "#000",
                            margin: "20px 0 0",
                          }}
                        >
                          <b>NON DISCLOSURE AGREEMENT</b>
                        </h2>
                      </td>
                    </tr>
                  </thead>
                  <tbody style={{ fontSize: "12pt" }}>
                    <tr>
                      <td
                        style={{
                          textAlign: "left",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          margin: "0",
                        }}
                      >
                        <p>
                          This Non-Disclosure Agreement (“Agreement”), is made
                          and entered into on this <br />
                          <b>{currentTodayDate}</b>-
                          <b>
                            {currentTodayMonth}-{currentTodayyear}
                          </b>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          textAlign: "center",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          margin: "0",
                        }}
                      >
                        <p style={{ margin: "0" }}>BY AND BETWEEN</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          textAlign: "justify",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          lineHeight: "1.5",
                          margin: "0",
                        }}
                      >
                        <p style={{ margin: "0" }}>
                          <b>InfoApto Technologies</b>, an Indian Company
                          incorporated under the Companies Act, 1956 with office
                          at 5/3 Block 2, Thirupur Kumaran Street, Chennai,
                          Tamil Nadu, 600045 (hereinafter referred as Disclosing
                          Party);
                        </p>
                      </td>
                    </tr>

                    <tr>
                      <td
                        style={{
                          textAlign: "left",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          lineHeight: "1.5",
                          margin: "0",
                        }}
                      >
                        <p style={{ textAlign: "center", margin: "0" }}>AND</p>
                        <p style={{ marginTop: "0" }}>
                          <b>{signData.fullName}</b>,an Indian Company
                          incorporated under the Companies Act, 1956 with office
                          at{" "}
                          <b>
                            {signData.address}, {signData.apartment},{" "}
                            {signData.city} - {signData.postalCode},{" "}
                            {signData.state}
                          </b>
                          . (hereinafter referred to as recipient)
                        </p>
                      </td>
                    </tr>

                    <tr>
                      <td
                        style={{
                          textAlign: "justify",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          lineHeight: "1.5",
                          margin: "0",
                        }}
                      >
                        <p>
                          Disclosing Party and Recipient are individually
                          referred to as “Party” and jointly referred to as
                          “Parties"
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          textAlign: "justify",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          lineHeight: "1.7",
                          margin: "0",
                        }}
                      >
                        <p>
                          WHEREAS, Disclosing Party is into the business of
                          manpower recruitment services;
                          <br />
                          WHEREAS, Recipient is an consultant of the Disclosing
                          Party; and
                          <br />
                          WHEREAS, the Disclosing Party intends to disclose
                          certain of its own Confidential Information as
                          <br />
                          well as its customers’ Confidential Information to the
                          Recipient, for whom the Recipient shall
                          <br />
                          work for, during his/her employment with the
                          Disclosing Party.
                          <br />
                          Now therefore, the Parties agree as follows:
                          <ol
                            style={{
                              marginTop: "0",
                              paddingLeft: "20px",
                              listStylePosition: "outside",
                            }}
                          >
                            <li style={{ paddingLeft: "16px" }}>
                              <b>Confidential Information:</b> The Recipient
                              shall hold in confidence, the Confidential
                              Information received from the Disclosing Party.
                              For purposes of this Agreement, the term
                              “Confidential Information” shall mean any and all
                              information or materials regarding the products,
                              services, activities, including (without
                              limitation) data, plans, photographs, drawings,
                              designs, strains, specifications, formulae,
                              compositions, inventions, discoveries, processes,
                              know-how, reports, studies, consultants reports,
                              trade secrets, and other financial and
                              trade/commercial information, contracts and client
                              database, computer models and programs, contracts,
                              plant designs and configurations, tactical
                              scientific, statistical, commercial or technical
                              information of any kind whether in existence at
                              the date hereof or hereafter to come into
                              existence including any copies, reproductions,
                              duplicates or notes in any form whatsoever that
                              are disclosed or provided by or on behalf of
                              Disclosing Party or on behalf of its customers to
                              the Recipient whether in written, machine readable
                              or other tangible form marked as Confidential by
                              the Disclosing party or intangible form.
                            </li>
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                          </ol>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style={styles.masterContainerTwo}>
                <table
                  style={{
                    fontSize: "12px",
                    lineHeight: "20px",
                    width: "100%",
                  }}
                >
                  <tbody style={{ fontSize: "12pt" }}>
                    <tr>
                      <br />
                    </tr>
                    <tr>
                      <td
                        style={{
                          textAlign: "justify",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          lineHeight: "1.7",
                          margin: "0",
                        }}
                      >
                        <p>
                          <ol
                            start="2"
                            style={{
                              marginTop: "0",
                              paddingLeft: "20px",
                              listStylePosition: "outside",
                            }}
                          >
                            <li style={{ paddingLeft: "16px" }}>
                              <b>Obligations:</b> : Recipient undertakes that:
                              <br />
                              <ol
                                style={{
                                  paddingLeft: "16px",
                                  listStylePosition: "outside",
                                }}
                                type="a"
                              >
                                <li style={{ paddingLeft: "16px" }}>
                                  The Recipient shall disclose the Confidential
                                  Information only in the course of performance
                                  of his/her duties and who are bound to protect
                                  the confidentiality of the information.
                                </li>
                                <li style={{ paddingLeft: "16px" }}>
                                  The Recipient shall use such Confidential
                                  Information only for the purpose for which it
                                  was disclosed and shall not use or exploit
                                  such Confidential Information for his/her own
                                  benefit or for benefit of another without the
                                  prior written consent of the Disclosing Party.
                                </li>
                                <li style={{ paddingLeft: "16px" }}>
                                  If so requested by the Disclosing Party, to
                                  return or destroy any documents or any copies
                                  thereof containing the Confidential
                                  Information and any samples of materials
                                  supplied by the Disclosing Party. Such return
                                  however does not abrogate the continuing
                                  obligations of Recipient under this Agreement.
                                </li>
                                <li style={{ paddingLeft: "16px" }}>
                                  In the event that Recipient is required by law
                                  in any judicial or governmental proceeding to
                                  disclose Confidential Information, Recipient
                                  will give Disclosing Party prior written
                                  notice of such request so that Disclosing
                                  Party may seek a protective order or
                                  appropriate remedy.
                                </li>
                                <li style={{ paddingLeft: "16px" }}>
                                  Recipient shall take the same degree of care
                                  that he/she uses to protect his/her own
                                  confidential and proprietary information and
                                  materials of similar nature and importance
                                  (but in no event less than reasonable care) to
                                  protect the confidentiality and avoid the
                                  unauthorized use, disclosure, publication or
                                  dissemination of the Confidential Information.
                                </li>
                                <li style={{ paddingLeft: "16px" }}>
                                  Recipient will not reverse engineer,
                                  de-compile or disassemble the Confidential
                                  Information disclosed to Recipient.
                                </li>
                                <li style={{ paddingLeft: "16px" }}>
                                  Recipient acknowledges that all intellectual
                                  property rights arising from Recipient's use
                                  of the Confidential Information (including
                                  copyright, design and patent rights) will on
                                  creation vest in and become the exclusive
                                  property of Disclosing Party and Recipient
                                  agrees to do all things and execute all
                                  documents as requested by Disclosing Party to
                                  give full effect to this provision.
                                </li>
                                <li style={{ paddingLeft: "16px" }}>
                                  With respect to Confidential Information, the
                                  Disclosing Party makes no warranties of
                                  accuracy, reliability, completeness,
                                  merchantability or fitness for any purpose.
                                  Confidential Information is provided on an
                                  “as-is” basis and the Disclosing Party
                                  expressly disclaims any warranties with
                                  respect to the Confidential Information.
                                </li>
                                <li style={{ paddingLeft: "16px" }}>
                                  No license expressed or implied in the
                                  Confidential Information is granted to
                                  Recipient other than to use the Confidential
                                  Information in the manner and to the extent
                                  authorized by this Agreement.
                                </li>
                              </ol>
                            </li>
                          </ol>
                          <br />
                          <br />
                          <br />
                          <br />
                          <br />
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div style={styles.masterContainerThree}>
                <table
                  style={{
                    fontSize: "12px",
                    lineHeight: "20px",
                    width: "100%",
                  }}
                >
                  <tbody style={{ fontSize: "12pt" }}>
                    <tr>
                      <td
                        style={{
                          textAlign: "justify",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          lineHeight: "1.7",
                          margin: "0",
                        }}
                      >
                        <p>
                          <ol
                            start="3"
                            style={{
                              marginTop: "0",
                              paddingLeft: "20px",
                              listStylePosition: "outside",
                            }}
                          >
                            <li style={{ paddingLeft: "16px" }}>
                              <b>Exceptions:</b> The provisions mentioned under
                              clause 2 shall not apply in the following cases:
                              <br />
                              <ol
                                type="a"
                                style={{
                                  paddingLeft: "16px",
                                  listStylePosition: "outside",
                                }}
                              >
                                <li style={{ paddingLeft: "16px" }}>
                                  The confidential information received from the
                                  Disclosing Party was already known to the
                                  Recipient and the Recipient shall if required,
                                  provide written records as proof for this.
                                </li>
                                <li style={{ paddingLeft: "16px" }}>
                                  The confidential information was known to
                                  public or generally available to the public
                                  prior to the date of receipt.
                                </li>
                                <li style={{ paddingLeft: "16px" }}>
                                  The confidential information becomes known to
                                  the public or generally available to the
                                  public subsequent to the date it was received
                                  without the Recipient being responsible.
                                </li>
                              </ol>
                            </li>
                            <li style={{ paddingLeft: "16px" }}>
                              <b>Ownership:</b> The Recipient agrees that the
                              Disclosing Party is and shall remain the exclusive
                              owner of Confidential Information.
                            </li>
                            <li style={{ paddingLeft: "16px" }}>
                              <b>Term:</b> Unless the Parties otherwise agree in
                              writing, Recipient’s duty to protect Confidential
                              Information shall continue even after the
                              termination of employment/internship of the
                              Recipient from the Disclosing Party for whatever
                              reasons.
                            </li>
                            <li style={{ paddingLeft: "16px" }}>
                              <b>Return Of Documents:</b> The Recipient shall,
                              upon the request of the Disclosing Party return to
                              the Disclosing Party all Confidential Information
                              and other documents/material received from the
                              Company by the Recipient.
                            </li>
                            <li style={{ paddingLeft: "16px" }}>
                              <b>No Copies:</b> Confidential Information
                              supplied in tangible form shall not be reproduced
                              in any form without prior written permission from
                              Disclosing Party.
                            </li>
                            <li style={{ paddingLeft: "16px" }}>
                              <b>Entirety:</b> This Agreement supersedes all
                              prior agreement, written or oral, between the
                              Disclosing Party and the Recipient relating to the
                              subject matter of this Agreement. This Agreement
                              cannot be modified, in whole or in part, except by
                              an agreement in writing signed by both parties
                              hereto.
                            </li>
                            <li style={{ paddingLeft: "16px" }}>
                              <b>Remedy:</b> The Recipient agrees that the
                              disclosure of Confidential Information without the
                              express written consent of the Disclosing Party
                              will cause irreparable harm to the Disclosing
                              Party, and that any breach or threatened breach of
                              this Agreement by the Recipient will entitle the
                              Disclosing Party to injunctive relief, in addition
                              to any other legal remedies available to it, in
                              any court of competent jurisdiction.
                            </li>
                            <li style={{ paddingLeft: "16px" }}>
                              <b>Successors:</b> This Agreement will be binding
                              upon and inure to the benefit of the parties
                              hereto and their respective successors and
                              assigns.
                            </li>
                            <li style={{ paddingLeft: "16px" }}>
                              <b>No Waiver:</b> No failure or delay by the
                              Disclosing Party in exercising any rights under
                              this Agreement shall operate as a waiver thereof,
                              nor shall any rights or partial exercise thereof
                              preclude any other or future exercise of any such
                              rights or privileges hereunder.
                            </li>
                            <li style={{ paddingLeft: "16px" }}>
                              <b>No Amendment:</b> No modification, amendment or
                              waiver of any provision of the terms of this
                              Agreement shall be effective unless it is made in
                              writing and duly signed by each of the Parties
                              hereto.
                            </li>
                          </ol>
                          <br />
                          <br />
                          <br />
                          <br />
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div style={styles.masterContainerFour}>
                <table
                  style={{
                    fontSize: "12px",
                    lineHeight: "20px",
                    width: "100%",
                  }}
                >
                  <tbody style={{ fontSize: "12pt" }}>
                    <tr>
                      <td
                        style={{
                          textAlign: "justify",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          lineHeight: "1.7",
                          margin: "0",
                        }}
                      >
                        <p>
                          <ol
                            start="13"
                            className={classes.nonDisloseAgreeList}
                          >
                            <li style={{ paddingLeft: "16px" }}>
                              <b>
                                Governing Law, Jurisdiction, and Arbitration:
                              </b>{" "}
                              This Agreement shall be construed and interpreted
                              in accordance with the laws of India. Courts in
                              Chennai shall have exclusive jurisdiction. Any
                              dispute arising out this Agreement shall be
                              referred to arbitration in accordance with the
                              rules of Arbitration and Conciliation Act, 1996 in
                              force when notice of arbitration is sent as per
                              these rules. The venue of arbitration shall be
                              Chennai and the language of proceedings shall be
                              English.
                            </li>
                          </ol>
                        </p>
                      </td>
                    </tr>

                    <tr>
                      <td
                        style={{
                          textAlign: "justify",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          lineHeight: "1.5",
                          margin: "0",
                        }}
                      >
                        <p>
                          <b>
                            IN WITNESS WHEREOF, THE PARTIES HAVE EXECUTED THIS
                            AGREEMENT AS OF THE DATE HEREOF {currentTodayDate} -
                            {currentTodayMonth}-{currentTodayyear}
                          </b>
                        </p>
                        <br />
                        <p>
                          For <b>InfoApto Technologies</b>
                        </p>
                      </td>
                    </tr>

                    <tr>
                      <td
                        style={{
                          textAlign: "justify",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          lineHeight: "1.5",
                          margin: "0",
                          fontSize: "11pt",
                        }}
                      >
                        <p style={{ margin: "20px 0px" }}>
                          <b>Authorized Signatory</b> &nbsp;{" "}
                          <img
                            style={{ maxWidth: "160px", height: "45px" }}
                            src={signatoryAuthorized}
                            alt="authorized signature"
                          />{" "}
                        </p>
                        <br />
                        <p>
                          For{" "}
                          <b>
                            {userDetails?.recruiter &&
                              userDetails?.recruiter.companyName}
                          </b>
                        </p>
                        <br />
                      </td>
                    </tr>

                    <tr>
                      <td
                        style={{
                          textAlign: "justify",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          lineHeight: "1.5",
                          margin: "0",
                          fontSize: "11pt",
                          position: "relative",
                        }}
                      >
                        <p style={{ display: "flex" }}>
                          <b>Authorized Person Signature:</b>{" "}
                          <span
                            style={{
                              width: "200px",
                              display: "block",
                              borderBottom: "1px solid #000",
                              marginLeft: "10px",
                              padding: "0 10px",
                            }}
                          >
                            <img
                              src={croppedImgae}
                              style={{
                                position: "absolute",
                                top: "-20px",
                                left: "240px",
                                maxWidth: "160px",
                                height: "45px",
                                objectFit: "contain",
                              }}
                              alt="add_signature_here"
                            />
                            {!hideActionBtns && (
                              <div
                                style={{
                                  display: "flex",
                                  gap: "10px",
                                  position: "absolute",
                                  top: "-5px",
                                  left: "450px",
                                }}
                              >
                                <Tooltip
                                  title="Remove sign"
                                  placement="bottom"
                                  aria-label="delete"
                                >
                                  <DeleteIcon
                                    className={classes.toolIconDelete}
                                    onClick={(e) => {
                                      setCroppedImage(null);
                                    }}
                                  />
                                </Tooltip>
                                <Tooltip
                                  title="Edit Details"
                                  placement="bottom"
                                  aria-label="delete"
                                >
                                  <EditIcon
                                    className={classes.toolIcon}
                                    onClick={() => handleModalOpen()}
                                    // onClick={() => document.getElementById("editFileInput")?.click()}
                                  />
                                </Tooltip>
                              </div>
                            )}
                          </span>
                        </p>
                        <p style={{ display: "flex" }}>
                          <b>Authorized Person Name:</b>{" "}
                          <span
                            style={{
                              width: "200px",
                              display: "block",
                              borderBottom: "1px solid #000",
                              marginLeft: "10px",
                              padding: "0 10px",
                            }}
                          >
                            {signData.personName}
                          </span>
                        </p>
                        <p style={{ display: "flex" }}>
                          <b>Designation:</b>{" "}
                          <span
                            style={{
                              width: "200px",
                              display: "block",
                              borderBottom: "1px solid #000",
                              marginLeft: "10px",
                              padding: "0 10px",
                            }}
                          >
                            {signData.designation}
                          </span>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "20px",
                margin: "0px 20px 20px 20px",
              }}
            >
              <Button
                variant="contained"
                size="small"
                color="secondary"
                onClick={handleClearFormData}
              >
                Clear
              </Button>
              <Button
                variant="contained"
                size="small"
                color="primary"
                className={classes.green}
                onClick={handleGeneratePdf}
              >
                I Agree
              </Button>
            </div>
          </div>

          <Dialog
            aria-labelledby="dialog-title"
            open={modalOpen}
            width="md"
            maxWidth="sm"
            PaperProps={{
              style: {
                width: "100%",
              },
            }}
          >
            <DialogContent
              style={{ overflowY: "unset" }}
              className={classes.center}
            >
              <Grid
                container
                direction="row"
                spacing={2}
                style={{ padding: "10px" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                    width: "100%",
                  }}
                >
                  <form onSubmit={handleSubmit(handleAddAgreement)}>
                    <Grid container direction="row" spacing={2}>
                      <Grid item xs={12} lg={6}>
                        <InputLabel shrink htmlFor="fullName">
                          Company Name <i>(as per GST)</i>
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            InputProps={{ disableUnderline: true }}
                            classes={{ root: classes.customTextField }}
                            size="small"
                            placeholder="Enter Your Company Name"
                            id="fullName"
                            error={errors.fullName ? true : false}
                            {...register("fullName")}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.fullName?.message}
                          </Typography>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <InputLabel shrink htmlFor="personName">
                          Authorized Person Name
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            InputProps={{ disableUnderline: true }}
                            classes={{ root: classes.customTextField }}
                            size="small"
                            placeholder="Enter Your Company Name"
                            id="personName"
                            error={errors.personName ? true : false}
                            {...register("personName")}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.personName?.message}
                          </Typography>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <InputLabel shrink htmlFor="designation">
                          Designation
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            InputProps={{ disableUnderline: true }}
                            classes={{ root: classes.customTextField }}
                            size="small"
                            placeholder="Enter Your Designation"
                            id="designation"
                            error={errors.designation ? true : false}
                            {...register("designation")}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.designation?.message}
                          </Typography>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <InputLabel shrink htmlFor="address">
                          Company Address
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            InputProps={{ disableUnderline: true }}
                            classes={{ root: classes.customTextField }}
                            size="small"
                            placeholder="Enter Your Company Address"
                            id="address"
                            error={errors.address ? true : false}
                            {...register("address")}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.address?.message}
                          </Typography>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <InputLabel shrink htmlFor="apartment">
                          Apartment, suite, etc.
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            InputProps={{ disableUnderline: true }}
                            classes={{ root: classes.customTextField }}
                            size="small"
                            placeholder="Enter Apartment, suite, etc. "
                            id="apartment"
                            error={errors.apartment ? true : false}
                            {...register("apartment")}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.apartment?.message}
                          </Typography>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <InputLabel shrink htmlFor="city">
                          City
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            InputProps={{ disableUnderline: true }}
                            classes={{ root: classes.customTextField }}
                            size="small"
                            placeholder="Enter Your City Name"
                            id="city"
                            error={errors.city ? true : false}
                            {...register("city")}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.city?.message}
                          </Typography>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <InputLabel shrink htmlFor="postalCode">
                          ZIP/postal code
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            InputProps={{ disableUnderline: true }}
                            classes={{ root: classes.customTextField }}
                            size="small"
                            placeholder="Enter Your ZIP/postal code"
                            id="postalCode"
                            error={errors.postalCode ? true : false}
                            {...register("postalCode")}
                            autoComplete="postal-code"
                          />

                          <Typography variant="inherit" color="error">
                            {errors.postalCode?.message}
                          </Typography>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <InputLabel shrink htmlFor="state">
                          State/province
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            InputProps={{ disableUnderline: true }}
                            classes={{ root: classes.customTextField }}
                            size="small"
                            placeholder="Enter Your State/province Name"
                            id="state"
                            error={errors.state ? true : false}
                            {...register("state")}
                          />

                          <Typography variant="inherit" color="error">
                            {errors.state?.message}
                          </Typography>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <InputLabel shrink htmlFor="signature">
                          Signature
                        </InputLabel>

                        <FormControl className={classes.margin}>
                          <div
                            className={
                              classes.space + " " + classes.alignItemsEnd
                            }
                          >
                            <div className={classes.marginTop}>
                              <input
                                accept=".jpg,.jpeg,.png"
                                className={classes.input}
                                id="fileInput"
                                type="file"
                                style={{ display: "none", height: "100%" }}
                                onChange={handleFileChange}
                              />
                              <label
                                htmlFor="icon-button-profile"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                <Button
                                  type="button"
                                  variant="contained"
                                  className={classes.button}
                                  color="primary"
                                  aria-label="upload signature"
                                  onClick={() =>
                                    document
                                      .getElementById("fileInput")
                                      ?.click()
                                  }
                                >
                                  Signature
                                </Button>
                                {croppedImgae && (
                                  <CheckCircleIcon
                                    style={{ color: "#06D001" }}
                                  />
                                )}
                              </label>
                            </div>
                          </div>
                        </FormControl>

                        <Typography variant="inherit" color="error">
                          {errors.files?.message}
                        </Typography>
                      </Grid>
                    </Grid>
                    <div
                      style={{
                        margin: "10px 15px",
                        flex: 1,
                        display: "flex",
                        justifyContent: "center",
                        gap: "10px",
                      }}
                    >
                      {/* <Button
                        variant="contained"
                        type="button"
                        size="small"
                        onClick={handleModalClose}
                      >
                        Close
                      </Button> */}
                      <Button
                        variant="contained"
                        type="submit"
                        size="small"
                        className={classes.green}
                      >
                        Submit
                      </Button>
                    </div>
                  </form>
                </div>
              </Grid>
            </DialogContent>
          </Dialog>

          <Dialog
            aria-labelledby="dialog-title"
            open={showModal}
            width="md"
            maxWidth="sm"
            PaperProps={{
              style: {
                width: "100%",
              },
            }}
            onClose={() => setShowModal(false)}
          >
            <DialogContent>
              <div
                className={`${classes.heading} ${classes.inputRoot} ${classes.pdfModalTitleText}`}
              >
                <Typography variant="subtitle2" className={classes.inputRoot}>
                  {" "}
                  Crop Image{" "}
                </Typography>

                <div className={classes.pdfModalCloseBtn}>
                  <CloseIcon className={classes.closeBtn} />
                </div>
              </div>
              <div
                className="d-flex"
                style={{ position: "sticky", minHeight: "50vh" }}
              >
                {imageSrc && (
                  <div className="crop-container">
                    <Cropper
                      image={imageSrc}
                      crop={crop}
                      zoom={zoom}
                      aspect={16 / 9}
                      onCropChange={setCrop}
                      onCropComplete={onCropComplete}
                      onZoomChange={setZoom}
                    />
                  </div>
                )}
              </div>
              <div className={classes.sendWhatsapp + " " + classes.inputRoot}>
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  onClick={() => {
                    setShowModal(false);
                    setCroppedImage(null);
                    setImageSrc(null);
                  }}
                >
                  Close
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  onClick={handleUpload}
                >
                  Crop
                </Button>
              </div>
            </DialogContent>
          </Dialog>

          <ToastContainer
            closeButton={
              <CloseButton className={classes.notificationCloseButton} />
            }
            closeOnClick={false}
            hideProgressBar={true}
          />
          <Backdrop className={classes.backdrop} open={loader}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </>
      </MuiThemeProvider>
    </div>
  );
}

export default VendorDisclosureAgreement;
function CloseButton({ closeToast, className }) {
  return <CloseIcon className={className} onClick={closeToast} />;
}
